/* =============================================================================
   MHV.renderPickupSlots — shared pickup-day/time picker.
   Used by the per-auction registration modal (mhv-auction-register.js) AND the
   custom checkout page (mhv-checkout.js) so both stay identical.

   MHV.renderPickupSlots(el, {
     pickupDays: [{date,start,end,location,location_detail}],  // event.pickup_days
     location:  'franklin_nh' | 'jaffrey_nh' | 'franklin' | 'jaffrey',
     selected:  {date,start,end,location,flexible} | null,     // current choice
     onChange:  function(slot) {},                             // slot or null
     catchAllLabel: "I'll reach out to schedule",
     changeNote: true,                                         // show "change later" note
     emptyNote: '<p>…</p>'                                     // HTML shown when a location
                                                               // has no days (overrides the
                                                               // default "no set times" copy)
   }) -> { get: fn }   // get() returns the current slot

   Renders up to 3 date pills inline, a "Show N more" toggle, a triple-wide
   catch-all pill, and (optionally) a change-later note. Self-injects its CSS.
   ============================================================================= */
(function () {
  var MHV = (window.MHV = window.MHV || {});
  var STYLE_ID = 'mhv-pp-styles';

  function esc(s) { return MHV.escapeHtml ? MHV.escapeHtml(String(s == null ? '' : s)) : String(s == null ? '' : s); }

  function normLoc(l) {
    l = String(l || '').toLowerCase();
    if (l.indexOf('franklin') >= 0) return 'franklin';
    if (l.indexOf('jaffrey') >= 0) return 'jaffrey';
    return l;
  }

  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fmtDate(dateStr) {
    if (!dateStr) return '';
    var d = new Date(String(dateStr).slice(0, 10) + 'T00:00:00');
    if (isNaN(d.getTime())) return dateStr;
    return DOW[d.getDay()] + ', ' + MON[d.getMonth()] + ' ' + d.getDate();
  }
  // Admin-entered local times (HH:MM), shown as-is in 12h — no TZ math.
  function fmtTime(t) {
    if (!t) return '';
    var p = String(t).split(':');
    var h = parseInt(p[0], 10); var m = parseInt(p[1] || '0', 10);
    if (isNaN(h)) return t;
    var ap = h >= 12 ? 'pm' : 'am';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return m === 0 ? (h12 + ap) : (h12 + ':' + (m < 10 ? '0' + m : m) + ap);
  }
  function timeRange(r) {
    if (r.start && r.end) return fmtTime(r.start) + '–' + fmtTime(r.end);
    if (r.start) return fmtTime(r.start);
    return '';
  }
  function slotKey(s) {
    if (!s) return '';
    return s.flexible ? 'flex' : (String(s.date || '') + '|' + (s.start || ''));
  }
  function daysUntil(dateStr) {
    if (!dateStr) return null;
    var today = new Date(new Date().toLocaleDateString('en-CA') + 'T00:00:00');
    var d = new Date(String(dateStr).slice(0, 10) + 'T00:00:00');
    if (isNaN(d.getTime())) return null;
    return Math.round((d - today) / 86400000);
  }
  function locName(l) { l = normLoc(l); return l === 'jaffrey' ? 'Jaffrey' : l === 'franklin' ? 'Franklin' : 'that location'; }

  MHV.renderPickupSlots = function (el, opts) {
    opts = opts || {};
    if (!el) return { get: function () { return null; } };
    injectStyles();

    var loc = normLoc(opts.location);
    var days = (opts.pickupDays || []).filter(function (r) { return r && r.date && normLoc(r.location) === loc; });
    days.sort(function (a, b) { return (String(a.date) + (a.start || '')).localeCompare(String(b.date) + (b.start || '')); });
    var selected = opts.selected || null;
    var catchAll = opts.catchAllLabel || "I'll reach out to schedule";
    var showAll = false;
    // No set pickup times for this location → default the choice to "reach out" so the
    // buyer doesn't have to pick a non-existent slot; the copy asks THEM to contact us.
    if (!days.length && !selected) {
      selected = { flexible: true, location: loc };
      if (typeof opts.onChange === 'function') opts.onChange(selected);
    }

    function slotFromDay(r) {
      return { date: r.date, start: r.start || null, end: r.end || null, location: loc, locationDetail: r.location_detail || null, flexible: false };
    }
    function choose(slot) { selected = slot; if (typeof opts.onChange === 'function') opts.onChange(slot); render(); }

    function render() {
      var html = '<div class="mhv-pp">';
      if (days.length) {
        var visible = showAll ? days : days.slice(0, 3);
        html += '<div class="mhv-pp-grid">';
        visible.forEach(function (r) {
          var s = slotFromDay(r);
          var sel = selected && !selected.flexible && slotKey(selected) === slotKey(s);
          var tr = timeRange(r);
          html += '<button type="button" class="mhv-pp-pill' + (sel ? ' mhv-pp-pill--sel' : '') + '" data-idx="' + days.indexOf(r) + '">'
            + '<span class="mhv-pp-date">' + esc(fmtDate(r.date)) + '</span>'
            + (tr ? '<span class="mhv-pp-time">' + esc(tr) + '</span>' : '')
            + '</button>';
        });
        html += '</div>';
        if (days.length > 3 && !showAll) html += '<button type="button" class="mhv-pp-more" data-more="1">Show ' + (days.length - 3) + ' more</button>';
      } else {
        // The caller may know a better reason than "none scheduled" — the Franklin
        // transfer cut-off being the case in point. Telling a buyer we have no Franklin
        // times, when really they have just missed Friday's van, is the kind of wrong
        // that becomes a phone call.
        html += '<div class="mhv-pp-none">' + (opts.emptyNote ||
          ('We don’t have set pickup times for ' + esc(locName(loc)) + ' right now. Please reach out and we’ll schedule one with you — call or text <a href="tel:+16034516960">(603) 451-6960</a>.')) + '</div>';
      }
      var fsel = selected && selected.flexible;
      html += '<button type="button" class="mhv-pp-catchall' + (fsel ? ' mhv-pp-pill--sel' : '') + '" data-flex="1">📞 ' + esc(catchAll) + '</button>';
      // Lead-time advisory: if a concrete date is chosen within the lead window, items
      // may not be on-site yet at the chosen location (they can live at either) — nudge
      // a call to confirm. leadTimeDays defaults to 2; set 0 to disable.
      var lead = (opts.leadTimeDays == null) ? 2 : opts.leadTimeDays;
      if (lead > 0 && selected && !selected.flexible && selected.date) {
        var du = daysUntil(selected.date);
        if (du != null && du >= 0 && du <= lead) {
          html += '<p class="mhv-pp-lead">⚠️ Picking up this soon? Please call <a href="tel:+16034516960">(603) 451-6960</a> to confirm your items are on-site at ' + esc(locName(loc)) + ' — we may need a little notice to bring them over.</p>';
        }
      }
      if (opts.changeNote !== false) html += '<p class="mhv-pp-note">You can change this anytime — we’ll confirm before you come.</p>';
      html += '</div>';
      el.innerHTML = html;

      el.querySelectorAll('.mhv-pp-pill[data-idx]').forEach(function (b) {
        b.addEventListener('click', function () { choose(slotFromDay(days[parseInt(b.getAttribute('data-idx'), 10)])); });
      });
      var more = el.querySelector('.mhv-pp-more');
      if (more) more.addEventListener('click', function () { showAll = true; render(); });
      var ca = el.querySelector('.mhv-pp-catchall');
      if (ca) ca.addEventListener('click', function () { choose({ flexible: true, location: loc }); });
    }

    render();
    return { get: function () { return selected; } };
  };

  // ---- Multi-location pickup-restriction helpers (checkout + reg-check) -------
  // A lot's effective pickup set is an array subset of ['franklin','jaffrey','onsite']
  // (resolved server-side). Empty/absent = no restriction (unrestricted → both ours).
  MHV.normPickupLoc = normLoc;
  MHV.pickupLocLabel = function (k) { k = normLoc(k); return k === 'franklin' ? 'Franklin' : k === 'jaffrey' ? 'Jaffrey' : k === 'onsite' ? 'Onsite' : ''; };
  // Schedulable (our-location) options for a lot: unrestricted → both; else the
  // franklin/jaffrey subset (empty for an onsite-only lot).
  MHV.pickupScheduleLocs = function (eff) {
    var a = Array.isArray(eff) ? eff : [];
    if (!a.length) return ['franklin', 'jaffrey'];
    return a.filter(function (k) { return k === 'franklin' || k === 'jaffrey'; });
  };
  MHV.pickupIsOnsiteOnly = function (eff) {
    var a = Array.isArray(eff) ? eff : [];
    return a.indexOf('onsite') !== -1 && !a.some(function (k) { return k === 'franklin' || k === 'jaffrey'; });
  };
  // Order-level summary across all lots: which of our locations to offer + onsite present.
  MHV.pickupSummary = function (items) {
    var set = { franklin: false, jaffrey: false }, hasOnsite = false;
    (items || []).forEach(function (it) {
      var eff = it && it.pickupLocations;
      if (MHV.pickupIsOnsiteOnly(eff)) { hasOnsite = true; return; }
      MHV.pickupScheduleLocs(eff).forEach(function (k) { set[k] = true; });
    });
    return { locations: ['franklin', 'jaffrey'].filter(function (k) { return set[k]; }), hasOnsite: hasOnsite };
  };
  // Per-lot badge relative to a chosen pickup location (chosenLoc may be null).
  // Returns { text, kind: 'onsite'|'conflict'|'info' } or null (no badge needed).
  MHV.pickupItemBadge = function (eff, chosenLoc) {
    if (MHV.pickupIsOnsiteOnly(eff)) return { text: 'Onsite — we’ll arrange', kind: 'onsite' };
    var sched = MHV.pickupScheduleLocs(eff);
    if (sched.length === 1) {
      var only = sched[0];
      var conflict = chosenLoc && normLoc(chosenLoc) !== only;
      return { text: MHV.pickupLocLabel(only) + ' pickup only', kind: conflict ? 'conflict' : 'info' };
    }
    return null; // unrestricted or both-allowed → any of our locations works
  };

  // Human summary of a stored slot (for confirmations / reg-check display).
  MHV.pickupSlotLabel = function (slot) {
    if (!slot) return '';
    if (slot.flexible) return 'Will reach out to schedule';
    var d = fmtDate(slot.date); var t = timeRange(slot);
    // "I'll take it home on auction day" — a real day/time, but the desk and the
    // account page should read it as attendance, not a booked collection.
    if (slot.auctionDay) return 'At the auction — ' + d + (t ? ' · ' + t : '');
    return d + (t ? ' · ' + t : '');
  };

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '.mhv-pp{margin-top:10px}',
      '.mhv-pp-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}',
      '.mhv-pp-pill{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;',
      'padding:10px 8px;border-radius:10px;cursor:pointer;text-align:center;',
      'border:1px solid rgba(94,145,152,0.35);background:rgba(94,145,152,0.06);',
      'color:inherit;font:inherit;line-height:1.2}',
      '.mhv-pp-pill:hover{border-color:#5E9198}',
      '.mhv-pp-pill--sel{background:#2C5F63;border-color:#2C5F63;color:#fff}',
      '.mhv-pp-date{font-weight:700;font-size:13px}',
      '.mhv-pp-time{font-size:12px;opacity:0.85}',
      '.mhv-pp-more{margin-top:8px;background:none;border:none;color:#5E9198;',
      'font-weight:600;font-size:13px;cursor:pointer;padding:4px 2px;text-decoration:underline}',
      '.mhv-pp-catchall{display:block;width:100%;box-sizing:border-box;margin-top:8px;padding:11px 10px;',
      'border-radius:10px;cursor:pointer;text-align:center;font:inherit;font-weight:600;',
      'border:1px dashed rgba(94,145,152,0.5);background:transparent;color:inherit}',
      '.mhv-pp-catchall:hover{border-style:solid;border-color:#5E9198}',
      '.mhv-pp-catchall.mhv-pp-pill--sel{background:#2C5F63;border-style:solid;border-color:#5E9198;color:#fff}',
      '.mhv-pp-none{font-size:13px;opacity:0.8;margin-bottom:2px}',
      '.mhv-pp-lead{font-size:12.5px;margin:8px 0 0;padding:8px 10px;border-radius:8px;line-height:1.4;',
      'background:rgba(214,158,46,0.12);border:1px solid rgba(214,158,46,0.4);color:#8a6420}',
      '.mhv-pp-lead a{color:inherit;font-weight:700}',
      '.mhv-pp-note{font-size:12px;opacity:0.75;margin:8px 0 0}',
      '@media(max-width:480px){.mhv-pp-grid{grid-template-columns:1fr}}'
    ].join('');
    document.head.appendChild(s);
  }
})();
